<template>
    <div class="withdraw">
        <div class="topTitle">
            <p class="title">
                提现
            </p>
            <Button class="withdrawBtn" @click="withdrawRecord">
                <div class="withdrawBtn">
                    <span>提现记录</span>
                </div>
            </Button>
        </div>

        <div class="accountView van-hairline--top-bottom" @click="showAccount = true">
            <!--微信账户-->
            <template v-if="activeAccount.type === 'WX'">
                <img class='accountTypeIcon' src="../../../assets/images/ic_wechat.png" alt="">
                <div class="accountInfo">
                    <p class="accountText">微信账户 （到账账户）</p>
                    <p class="accountNum">{{ activeAccount.accountName }}</p>
                </div>
            </template>
            <!--支付宝账户-->
            <!-- <template v-else>
                <img class='accountTypeIcon' src="../../../assets/images/ic_alipay.png" alt="">
                <div class="accountInfo">
                    <p class="accountText">支付宝账户 （到账账户）</p>
                    <p class="accountNum">{{activeAccount.account}}</p>
                </div>
            </template> -->
            <span class="arrow">
                <Icon name="arrow" />
            </span>
        </div>
        <div class="form van-hairline--top-bottom">
            <p class="tipsTitle">提现金额（元）</p>
            <div class="inputView van-hairline--bottom">
                <span class="tag">¥</span>
                <input class="input" type="text" v-model="form.amount" placeholder="请输入金额" v-on:input="onAmountInput" />
                <span class="clearIcon" @click="clearAmount" v-if="form.amount !== ''">
                    <Icon name="clear" />
                </span>
            </div>
            <div class="tipsView">
                <div>
                    <span>*</span>可提现：¥{{ userInfo.cashAmount }}
                </div>
                <div>
                    <span>*</span>手续费：{{ charge }}元(每笔扣取{{ rateText }}%每笔固定扣取{{ fee }}元)
                </div>
                <div>
                    <span>*</span>实际到账：{{ reality }}元
                </div>
                <div>
                    <span>*</span>最低提现金额不小于{{ lowestMoney }}元，单次提现金额不超过{{ limitMax }}元，提现金额为整数
                </div>
            </div>
        </div>
        <p class="title">安全验证</p>
        <div class="verification">
            <div class="inputView van-hairline--bottom">
                <input class="input" type="text" v-model="form.smsCode" placeholder="请输入短信验证码" />
                <Button class="getCodeBtn" @click="transferValid">{{ codeText }}</Button>
            </div>
            <p class="phone">
                您当前绑定手机号为：{{ userInfo.mobile }}
            </p>
        </div>
        <Button class="confirmBtn" @click="verifyWithdraw">
            <span>立即提取</span>
        </Button>
        <template v-if="!authorized">
            <Button class="authorizationBtn" @click="handleMerchantTransfer">
                <span>授权收款</span>
            </Button>
            <div class="tips">
                <p>首次提现需先完成收款授权，授权成功后方可发起申请。</p>
            </div>
        </template>

        <Popup v-model="showAccount" :close-on-click-overlay="false">
            <div class="popupContent">
                <p class="popupTitle">选择账户</p>
                <RadioGroup v-model="type">
                    <CellGroup>
                        <Cell :title="item.type === 'WX' ? '微信账户' : '支付宝账户'" clickable
                            v-for="(item, index) in accountList" :key="index" @click="type = item.type">
                            <img src="../../../assets/images/ic_wechat.png" v-if="item.type === 'WX'"
                                class="accountIcon" slot="icon" alt="">
                            <!-- <img src="../../../assets/images/ic_alipay.png" v-else class="accountIcon" slot="icon"
                                 alt=""> -->
                            <Radio slot="right-icon" :name="item.type" />
                        </Cell>
                    </CellGroup>
                </RadioGroup>
                <div class="btnView">
                    <Button class="confirmBtn" @click="toPage('/drawMode')">
                        换绑
                    </Button>
                    <Button class="confirmBtn" @click="confirmAccount">
                        确定
                    </Button>
                </div>
            </div>
        </Popup>
        <Popup v-model="confirmShow" closeable close-icon-position="top-left" position="bottom" close-icon="close">
            <div class="confirmWithdraw">
                <!--支付宝账户-->
                <!-- <template v-if="activeAccount.type === 'ZFB'">
                    <img src="../../../assets/images/ic_alipay.png" alt="">
                    <p class="userName">{{activeAccount.account}}</p>
                    <p class="tips">即将提现至您的支付宝账号</p>
                </template> -->
                <!--微信账户-->
                <!-- <template v-else> -->
                <img src="../../../assets/images/ic_wechat.png" alt="">
                <p class="userName">{{ activeAccount.accountName }}</p>
                <p class="tips">即将提现至您的微信账号</p>
                <!-- </template> -->
                <Button class="confirmBtn" @click="confirmDraw">
                    确定
                </Button>
            </div>
        </Popup>
    </div>
</template>

<script>
/*
* 提现
* */
import { Icon, Button, Popup, RadioGroup, Radio, Cell, CellGroup } from 'vant';
import { getDrawConfig, getTransferAccount, getDrawSMS, confirmDraw as confirmDrawApi, getVxConfigs } from "../../../api/withdraw";
import { mapState } from 'vuex'

export default {
    name: "Withdraw",
    components: {
        Icon,
        Button,
        Popup,
        RadioGroup,
        Radio,
        Cell,
        CellGroup
    },
    data() {
        return {
            showAccount: false,
            confirmShow: false,
            lowestMoney: 0,
            limitMax: 0,
            form: {
                amount: '',
                smsCode: '',
                type: 'WX',
                appType: "WEB"
            },
            type: '',
            accountList: [],
            activeAccount: {},
            codeText: '获取验证码',
            num: 60,
            rate: 0,
            fee: 0,
            reality: 0,
            rateSwitch: '',
            feeSwitch: '',
            charge: 0,
            rateText: 0,
            authorized: false
        }
    },
    computed: {
        ...mapState(['userInfo'])
    },
    created() {
        //获取是否绑定收款授权
        getVxConfigs("withdraw").then(res => {
            this.authorized = res.authorized
        })

        // 获取提现配置
        getDrawConfig().then(res => {
            console.log(res)
            res.rateText = (res.rate * 100).toFixed(2);
            this.lowestMoney = res.limitMin;
            this.limitMax = res.limitMax;
            this.rate = res.rate,
                this.fee = res.fee
            this.rateSwitch = res.rateSwitch,
                this.feeSwitch = res.feeSwitch
            this.rateText = res.rateText
        });
        // 获取用户绑定的账户列表
        getTransferAccount().then(res => {

            const tempInfo = res.find(item => item.type === 'WX');
            if (tempInfo) {
                this.accountList = [tempInfo]
            }

            if (this.accountList) {
                this.form.type = this.accountList[0].type;
                this.type = this.accountList[0].type;
                this.activeAccount = this.accountList[0];
            }
        })
    },
    methods: {
        onAmountInput(event) {
            console.log(event)
            let value = this.form.amount;
            let rate = this.rate;
            let fee = this.fee;
            let charge = 0
            if (value) {
                if (this.rateSwitch === 'START') {
                    charge = value * rate;
                }
                if (this.feeSwitch === 'START') {
                    charge += fee;
                }
                this.form.amount = value
                console.log(this.form.amount)
                this.charge = charge.toFixed(2)
                this.reality = (value - charge.toFixed(2)).toFixed(2)
            }

        },
        // 提现记录
        withdrawRecord() {
             this.toPage("/recordList");
        },
        clearAmount() {
            this.form.amount = '';
        },
        // 确认提现
        confirmDraw() {
            confirmDrawApi(this.form).then(_ => {
                this.confirmShow = false;
                this.alert({
                    text: '提交成功，请留意微信提醒',
                    fn: _ => {
                        this.$store.dispatch('getUserInfo');
                        this.form.amount = '';
                        this.form.smsCode = '';
                    }
                })
            }).catch(_ => {
                this.confirmShow = false;
            })
        },

        // 获取手机验证码
        transferValid() {
            if (this.num !== 60) return this.toast({ text: `${this.num}秒后可再次获取`, icon: 'warning' });
            if (!this.userInfo.mobile) return this.toast({ text: '您还没有绑定手机号码', icon: 'warning' });
            getDrawSMS().then(_ => {
                let timer = null;
                timer = setInterval(() => {
                    if (this.num === 0) {
                        clearInterval(timer);
                        this.codeText = '获取验证码';
                        this.num = 60;
                    } else {
                        this.codeText = this.num + ' S';
                        this.num--;
                    }
                }, 1000);
            })
        },
        confirmAccount() {
            this.accountList.map(item => {
                if (item.type === this.type) {
                    this.activeAccount = item;
                    this.form.type = item.type;
                    this.form.appType = item.appType;
                    this.showAccount = false;
                }
            })
        },
        verifyWithdraw() {
            if (!this.form.amount) return this.toast({ text: '请输入金额', icon: 'warning' });
            if (!this.form.smsCode) return this.toast({ text: '请输入验证码', icon: 'warning' });
            if (this.lowestMoney > this.form.amount) return this.toast({
                text: `提现金额不可小于${this.lowestMoney}`,
                icon: 'warning'
            });
            if (this.limitMax < this.form.amount) return this.toast({
                text: `提现金额不可大于${this.limitMax}`,
                icon: 'warning'
            });
            this.confirmShow = true;
        },
        // 获取微信配置,进行提现
        async handleMerchantTransfer() {
            try {
                let res = await getVxConfigs("withdraw");
                if (res.authorized) {
                    //已绑定微信配置,进行提现
                    this.toast({
                        text: '您已经绑定微信配置,无需重复绑定!',
                        icon: 'warning'
                    });
                    this.authorized = true
                    return;
                }

                const configData = {
                    // debug: true,
                    appId: res.jsConfig.appId, // 必填，公众号的唯一标识
                    timestamp: res.jsConfig.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.jsConfig.nonceStr, // 必填，生成签名的随机串
                    signature: res.jsConfig.signature, // 必填，签名
                    jsApiList: ['requestMerchantTransfer'] // 必填，需要使用的JS接口列表
                };
                const realInfo = {
                    mchId: res.mchId,
                    appId: res.appid,
                    package: res.packageInfo,
                }

                wx.config(configData);

                wx.ready(function () {
                    wx.checkJsApi({
                        jsApiList: ['requestMerchantTransfer'],
                        success: function (res) {
                            if (res.checkResult['requestMerchantTransfer']) {
                                WeixinJSBridge.invoke('requestMerchantTransfer', {
                                    mchId: realInfo.mchId,
                                    appId: realInfo.appId,
                                    package: realInfo.package,
                                },
                                    function (res) {
                                        if (res.err_msg === 'requestMerchantTransfer:ok') {
                                            // res.err_msg将在页面展示成功后返回应用时返回success，并不代表付款成功
                                            // wx.showModal({
                                            //     title: '提示',
                                            //     content: '授权收款成功',
                                            //     showCancel: false,
                                            // });
                                            this.authorized = true
                                            alert("授权收款成功")
                                        }
                                        else if (res.err_msg === 'requestMerchantTransfer:fail') {
                                            // wx.showModal({
                                            //     title: '提示',
                                            //     content: '授权收款请求失败，请稍后重试',
                                            //     showCancel: false,
                                            // });
                                            alert("授权收款失败")
                                        } else if (res.err_msg === 'requestMerchantTransfer:cancel') {
                                            // wx.showModal({
                                            //     title: '提示',
                                            //     content: '授权收款请求已取消',
                                            //     showCancel: false,
                                            // });
                                            alert("授权收款取消")
                                        }
                                    }
                                );
                            } else {
                                alert('你的微信版本过低，请更新至最新版本。');
                                // wx.showModal({
                                //     title: '提示',
                                //     content: '当前微信版本过低，请升级后再试。',
                                //     showCancel: false,
                                // });
                            }
                        },
                        fail: function (res) {

                            wx.showModal({
                                title: '提示',
                                content: '检查JS接口失败，请稍后重试',
                                showCancel: false,
                            });
                        }
                    });
                });



            } catch (error) {
                this.confirmShow = false;
                this.toast({
                    text: '获取转账信息失败，请稍后重试',
                    icon: 'warning'
                });
            }

        },
    }
}
</script>

<style lang='less' scoped>
.withdraw {
    min-height: 100vh;
    background-color: #f9f9fb;

    .topTitle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 2vw 4.3vw;
        ;

        .title {
            // text-indent: 4.3vw;
            line-height: 8.4vw;
            font-size: 3.7vw;
            color: #1b1b4e;
        }

        .withdrawBtn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 20.7vw;
            height: 8.7vw;
            background-color: #2895ff;
            border-radius: 1.3vw;
            font-size: 3.2vw;
            color: #ffffff;
        }
    }



    .accountView {
        display: flex;
        align-items: center;
        margin-bottom: 2.4vw;
        padding: 5.2vw 5.3vw 5.5vw 4.3vw;
        background-color: white;

        .accountTypeIcon {
            width: 9.3vw;
            height: 9.3vw;
            margin-right: 3.7vw;
        }

        .accountInfo {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .accountText {
                margin-bottom: 2vw;
                font-size: 3.2vw;
                color: #aeb3c0;
            }

            .accountNum {
                font-size: 4.8vw;
                color: #1b1b4e;
            }
        }

        .arrow {
            color: #e5e5e5;
            font-weight: bold;
        }
    }

    .form {
        padding: 0 4vw;
        background-color: white;

        .tipsTitle {
            line-height: 8.3vw;
            font-size: 2.7vw;
            color: #1b1b4e;
        }

        .inputView {
            display: flex;
            align-items: center;
            height: 15.2vw;

            .tag {
                margin-right: 3.2vw;
                font-size: 6.4vw;
                color: #000000;
            }

            .input {
                flex: 1;
                border: none;
                font-size: 6.2vw;
                color: #000;
            }

            .clearIcon {
                font-size: 4vw;
                color: #d4dbe3;
            }
        }

        .tipsView {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 3.5vw 0;

            div {
                font-size: 2.7vw;
                color: #242424;

                span {
                    color: #ec1a1a;
                }
            }
        }
    }

    .verification {
        padding: 0 4vw;
        background-color: white;

        .inputView {
            display: flex;
            align-items: center;
            padding: 4.7vw 0 1.7vw;

            .input {
                flex: 1;
                height: 5.3vw;
                border: none;
                font-size: 3.2vw;
                line-height: 5.3vw;

                &::placeholder {
                    color: #aeb3c0;
                }
            }

            .getCodeBtn {
                width: 20vw;
                height: 5.3vw;
                padding: 0;
                margin-left: 5vw;
                border: none;
                line-height: 5.3vw;
                background-color: #43a2fe;
                border-radius: 1.3vw;
                font-size: 2.7vw;
                color: #ffffff;
            }
        }

        .phone {
            line-height: 8vw;
            font-size: 2.7vw;
            color: #1a1a1a;
        }
    }

    .confirmBtn {
        display: block;
        width: 53.3vw;
        height: 11.7vw;
        margin: 5.6vw auto 0;
        border: none;
        line-height: 11.7vw;
        background-color: #43a2fe;
        border-radius: 6.7vw;
        font-size: 4vw;
        color: #ffffff;
    }

    .authorizationBtn {
        display: block;
        width: 53.3vw;
        height: 11.7vw;
        margin: 5.6vw auto 0;
        border: none;
        line-height: 11.7vw;
        background-color: #ecf5ff;
        border-radius: 6.7vw;
        font-size: 4vw;
        color: #409eff;
        border: 1px solid #b3d8ff;
    }

    .tips {
        font-size: 3vw;
        margin: 5.6vw;
        line-height: 8vw;
        color: #101010;
        text-align: center;
    }

    .van-popup.van-popup--center {
        border-radius: 2.7vw;

        .popupContent {
            width: 77.7vw;
            /*height: 53.9vw;*/
            padding: 0 5.5vw 4.9vw;
            background-color: #ffffff;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;

            .popupTitle {
                text-align: center;
                line-height: 14.2vw;
                font-size: 4vw;
                color: #333333;
            }

            .accountIcon {
                width: 5.6vw;
                height: 5.6vw;
                margin-right: 4.1vw;
            }

            .van-cell.van-cell--clickable {
                padding-left: 0;
                padding-right: 0;

                &:not(:last-child)::after {
                    left: 0;
                }
            }

            .btnView {
                display: flex;
            }
        }

        .confirmBtn {
            width: 23.6vw;
            height: 8vw;
            margin-top: 5.2vw;
            line-height: 8vw;
            font-size: 3.2vw;
            background-color: #43a2fe;
            border-radius: 1.6vw;
        }
    }

    .confirmWithdraw {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 8vw;
        padding-bottom: 5.5vw;

        img {
            width: 14.7vw;
            height: 14.7vw;
            margin-bottom: 3.6vw;
        }

        .userName {
            font-size: 4.8vw;
            color: #101010;
        }

        .tips {
            margin-bottom: 7.7vw;
            font-size: 4vw;
            color: #101010;
        }

        .confirmBtn {
            width: 23.6vw;
            height: 8vw;
            margin: 0;
            line-height: 8vw;
            background-color: #43a2fe;
            border-radius: 1.6vw;
            font-size: 3.2vw;
            color: #ffffff;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/mine/withdraw/Withdraw.vue